<ng-container *transloco="let t; read: 'controls'">
  <div *ngIf="isVisible()" class="controls">
    <i *ngIf="isStopped() && !isStartable()" class="pi pi-ban p-ml-1 p-mt-1" [pTooltip]="t('busy_not_startable')" tooltipPosition="left"></i>
    <!--  -->
    <button *ngIf="isStartable()" pButton (click)="start($event)" [disabled]="sending" icon="pi pi-play" class="p-button-sm p-ml-1"></button>
    <button *ngIf="isPauseable()" pButton (click)="pause($event)" [disabled]="sending" icon="pi pi-pause" class="p-button-sm p-ml-1"></button>
    <button *ngIf="isResumeable()" pButton (click)="resume($event)" [disabled]="sending" icon="pi pi-play" class="p-button-sm p-ml-1"></button>
    <button *ngIf="isFinishable()" pButton (click)="finish($event)" [disabled]="sending" icon="pi pi-check" class="p-button-sm p-ml-1"></button>
    <button *ngIf="isResetable()" pButton (click)="reset($event)" [disabled]="sending" icon="pi pi-refresh" class="p-button-sm p-ml-1"></button>
  </div>
</ng-container>
